import * as React from "react";
import { useContext } from "react";
import { InputChangeEvent } from "@progress/kendo-react-inputs/dist/npm/input/interfaces/InputChangeEvent";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import TextInput from "../../../../../Layout/Inputs/TextInput";
import { EditProjectContext } from "../../../EditProjectContext";

type Props = {
  route: FtlRouteViewModel;
  isReadonly: boolean;
};

function LaunchBatch({ route, isReadonly }: Props) {
  const { project, setProject } = useContext(EditProjectContext);

  const handleLaunchBatchChange = (event: InputChangeEvent) => {
    setLaunchBatch(event.target.value as number);
    setLaunchBatchForRoute(route.RouteId, event.target.value as number);
  };

  const setLaunchBatchForRoute = (routeId: any, launchBatch: number) => {
    const updateFtlRoute = (ftlRoute: FtlRouteViewModel) => {
      return ftlRoute.RouteId === routeId
        ? {
            ...ftlRoute,
            LaunchBatch: launchBatch,
          }
        : ftlRoute;
    };

    setProject({
      ...project,
      FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
    });
  };

  const [launchBatch, setLaunchBatch] = React.useState(route.LaunchBatch);

  return (
    <TextInput
      label="Launch Batch"
      onChange={handleLaunchBatchChange}
      name="RouteNumber"
      type="number"
      value={launchBatch || ""}
      min={1}
      max={9}
      step={1}
      readOnly={isReadonly}
    />
  );
}

export default LaunchBatch;
